var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      staticClass: "modal-overlay",
      on: {
        click: function ($event) {
          $event.stopPropagation()
        },
      },
    },
    [
      _c("div", { staticClass: "modal-content" }, [
        _c("div", { staticClass: "modal-header" }, [
          _c("h2", { staticClass: "modal-title" }, [
            _vm._v(_vm._s(_vm.$t("camstudy.imageModal.title"))),
          ]),
        ]),
        _c("div", { staticClass: "modal-body" }, [
          _vm.showCropper
            ? _c(
                "div",
                { staticClass: "preview-container" },
                [
                  _c("cropper", {
                    staticClass: "cropper",
                    attrs: {
                      src: _vm.uploadImage.path,
                      options: { aspectRatio: 1 },
                      "stencil-props": { aspectRatio: 334 / 222 },
                    },
                    on: { change: _vm.onChangeCroppedImage },
                  }),
                ],
                1
              )
            : _vm.inProgressUpload
            ? _c(
                "div",
                { staticClass: "preview-container loading-container" },
                [
                  _c("div", { staticClass: "loading-spinner" }),
                  _c("p", { staticClass: "loading-text" }, [
                    _vm._v(_vm._s(_vm.$t("camstudy.imageModal.processing"))),
                  ]),
                ]
              )
            : _c("div", { staticClass: "preview-container" }, [
                _c("img", {
                  staticClass: "main-preview",
                  attrs: { src: _vm.selectedDefaultImage, alt: "defaultImage" },
                }),
              ]),
          _c(
            "div",
            { staticClass: "thumbnail-list" },
            [
              _vm._l(_vm.defaultImageList, function (img, index) {
                return _c(
                  "div",
                  {
                    key: index,
                    staticClass: "thumbnail-item",
                    class: {
                      "thumbnail-selected": _vm.selectedIndex === index,
                    },
                    on: {
                      click: function ($event) {
                        return _vm.handleThumbnailClick(index)
                      },
                    },
                  },
                  [
                    _c("img", {
                      attrs: {
                        src: img,
                        alt: _vm.$t("camstudy.imageModal.thumbnail"),
                      },
                    }),
                  ]
                )
              }),
              _c("button", {
                staticClass: "thumbnail-item upload",
                attrs: { disabled: _vm.inProgressUpload },
                on: { click: _vm.onOpenFile },
              }),
            ],
            2
          ),
        ]),
        _c(
          "div",
          {
            staticClass: "modal-footer",
            on: {
              click: function ($event) {
                $event.stopPropagation()
              },
            },
          },
          [
            _c(
              "button",
              { staticClass: "cancel-btn", on: { click: _vm.handleCancel } },
              [_vm._v(_vm._s(_vm.$t("common.cancel")))]
            ),
            _c(
              "button",
              {
                staticClass: "confirm-btn",
                attrs: { disabled: _vm.inProgressUpload },
                on: { click: _vm.handleConfirm },
              },
              [_vm._v(_vm._s(_vm.$t("common.confirm")))]
            ),
          ]
        ),
      ]),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }